import React from "react";
import styled from "styled-components";
import { breakpoints } from "../../styles/variables";
import Wrapper from "../Wrappers/Wrapper";

const SectionHeaderDiv = styled.div`
  padding: 34px 0 46px;
  h1 {
    text-align: center;
    font: 26px / 32px "FS Medium";
  }
  @media screen AND (min-width: ${breakpoints.desktop}px) {
    margin: 30px 0 60px;
    h1 {
      text-align: center;
      font: 36px / 36px "FS Medium";
    }
  }
`;

interface SectionHeaderProps {
  title: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title }) => (
  <Wrapper>
    <SectionHeaderDiv>
      <h1>{title}</h1>
    </SectionHeaderDiv>
  </Wrapper>
);

export default SectionHeader;
